import BaseService from "@/services/base.service";
import api from "@/services/api";

class WorkingScheduleService extends BaseService{

    workingScheduleAPI(str){
        return str ? "timesheet/working-schedule/" + str : "timesheet/working-schedule"  ;
    }

    destroy(ids){
        return this.destroy(ids);
    }
    create(data){
        return api.post(this.workingScheduleAPI("create"), data);
    }

    update(data){
        return api.post(this.workingScheduleAPI("update/" + data.schedule.id), data);
    }


    find(id){
        return api.get(this.workingScheduleAPI(id));
    }
}

export default new WorkingScheduleService();